import React from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { Modal, Button, ModalHeader } from "react-bootstrap";
import { useState, useEffect } from 'react';
import axios from "axios";
import { baseurladdress } from "../baseurl";
import { useNavigate } from "react-router-dom";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'

const Swal = require('sweetalert2');

const showToast = (icon, message) => {
    Swal.fire({
        toast: true,
        position: 'top-end',
        icon: icon, // 'success', 'error', 'info', etc.
        title: message,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
    });
};

function LeavePolicy(props) {
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const navigate = useNavigate();
    const [leavepolicydata, setleavepolicydata] = useState([]);

    const fetchLeavepolicydata = (e) => {
        console.log(accesstoken)
        axios
            .get(baseurladdress + "findleavepolicy", {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                setleavepolicydata(res.data.response);
            })
            .catch((error) => {
                console.error("Error fetching leave policies:", error);
                showToast('error', 'Failed to fetch leave policy details');
            });

    }

    useEffect(() => {
        fetchLeavepolicydata();
    }, [])
    function LeavePolicy() {
        navigate("/addleavepolicy");
    }
    function EditLeavePolicy(leavepolicy_num) {
        navigate("/editleavepolicy/" + leavepolicy_num);
    }
    function handleDeleteClick(ids) {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085D6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                {
                    axios
                        .post(baseurladdress + `deleteleavepolicy/` + ids, leavepolicydata, {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem("token")}`,
                            },
                        })
                        .then((result) => {
                            console.log("reslt:", result);
                            const Data = result.data.status;
                            if (Data == "deleted") {
                                 if ($.fn.DataTable.isDataTable('#leavepolicytable')) {
        $('#leavepolicytable').DataTable().destroy();
    }

    // update state immediately
    setleavepolicydata((prev) =>
        prev.filter((item) => item.leavepolicy_num !== ids)
    );
                                const Toast = Swal.mixin({
                                    toast: true,
                                    position: "top-end",
                                    showConfirmButton: false,
                                    timer: 2500,
                                    timerProgressBar: true,
                                    didOpen: (toast) => {
                                        toast.addEventListener("mouseenter", Swal.stopTimer);
                                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                                    },
                                });
                                Toast.fire({
                                    icon: "success",
                                    title: "Leave policytype Deleted Successfully",
                                });
                                fetchLeavepolicydata();
                            }
                        });
                }
            }
        });
    }

useEffect(() => {
    if ($.fn.DataTable.isDataTable('#leavepolicytable')) {
        $('#leavepolicytable').DataTable().destroy();
    }

    if (leavepolicydata.length > 0) {
        $('#leavepolicytable').DataTable();
    }
}, [leavepolicydata]);

    // $(function () {
    //     setTimeout(function () {
    //         $('#leavepolicytable').DataTable();
    //     }, 1000);
    // });
    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">
                        <section id="main-content">
                            <div className="card">
                                <div className="card-header" style={{ "color": "black" }}>
                                    <h6 className="card-title"> Leave Policy Details
                                    </h6>
                                    {/* <div className="row mb-2">
                                        <div className="col-sm-12 "> */}



                                    <div className="d-flex align-items-center">
                                        <button
                                            type="button"
                                            className="btn plus-icon d-flex align-items-center"
                                            onClick={() => LeavePolicy()}
                                            style={{ marginRight: '50px' }} // Adjust spacing as needed
                                        >
                                            <span style={{ fontSize: "1.2rem" }}><i className='fa fa-plus-circle text-success'></i></span>
                                            <span style={{ fontSize: "0.7rem", color: "black", padding: "5px" }}> Add</span>
                                        </button>
                                    </div>

                                    {/* </div>
                                    </div> */}
                                </div>
                                <div className="card-body">

                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="table-responsive">
                                                    <table className="table table-bordered table-responsive-sm" id="leavepolicytable">
                                                        <thead>
                                                            <tr>
                                                                <th>Sl.No</th>
                                                                <th>Policy</th>
                                                                <th>Branch </th>
                                                                <th>Type</th>
                                                                <th>Status</th>
                                                                <th>Edit</th>
                                                                <th>Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {leavepolicydata.length > 0 ? (
                                                                leavepolicydata.map((item, index) => (
                                                                    <tr key={item.leavepolicy_num} >
                                                                        <td >{index + 1}</td>
                                                                        <td>{item.leavepolicy_num}</td>
                                                                        {/* <td>{item.leavepolicy_branchname}</td> */}
                                                                        <td>
                                                                            {(() => {
                                                                                const branches = item.leavepolicy_branchname?.split(",") || [];

                                                                                if (branches.length > 3) {
                                                                                    return (
                                                                                        <span title={item.leavepolicy_branchname}>
                                                                                            {branches.slice(0, 3).join(", ")} ...
                                                                                        </span>
                                                                                    );
                                                                                }

                                                                                return item.leavepolicy_branchname;
                                                                            })()}
                                                                        </td>
                                                                        <td>{item.leavepolicy_leavetype}</td>

                                                                        <td>
                                                                            {item.leavepolicy_status === 1 ? (
                                                                                <span className="badge bg-success">Active</span>
                                                                            ) : (
                                                                                <span className="badge bg-danger">Inactive</span>
                                                                            )}
                                                                        </td>
                                                                        <td style={{ textAlign: "center" }}>
                                                                            <i
                                                                                className="text-primary fa fa-edit"
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => EditLeavePolicy(item.leavepolicy_num)}
                                                                            ></i>
                                                                        </td>
                                                                        <td style={{ textAlign: "center" }}>
                                                                            <i
                                                                                className="text-danger fa fa-trash"
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => handleDeleteClick(item.leavepolicy_num)}
                                                                            ></i>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="7" className="text-center">No data found</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            {/* /# column */}

                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LeavePolicy;